var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7233 2.15517L16 0.933837V0.666504H11.5773L8.42533 8.51184L4.83933 0.666504H0.202V0.933837L1.69333 2.72917C1.83867 2.86184 1.91467 3.05584 1.89533 3.25117V10.3065C1.94133 10.5605 1.85867 10.8218 1.68 11.0065L0 13.0425V13.3065H4.76333V13.0392L3.08333 11.0065C2.90133 10.8212 2.81533 10.5645 2.852 10.3065V4.20384L7.03333 13.3098H7.51933L11.1147 4.20384V11.4578C11.1147 11.6492 11.1147 11.6885 10.9893 11.8138L9.696 13.0652V13.3332H15.9707V13.0658L14.724 11.8452C14.6147 11.7625 14.558 11.6238 14.5813 11.4892V2.51117C14.558 2.37584 14.614 2.23717 14.7233 2.15517Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumLogo);
export default __webpack_public_path__ + "static/media/medium-logo.45a590016bc60407175cb70d7f81ff61.svg";
export { ForwardRef as ReactComponent };